<template>
  <div class="audio-flex uk-margin-medium-top">
    <div class="uk-flex uk-flex-column demo-images">
      <img src="../assets/images/commercieel@2x.png">
      <div class="audio-player-styling">
        <audio-player
          ref="audioPlayerCommercieel"
          :audio-list="audioListCommercieel.map(elm => elm.url)"
          theme-color="#3E332C"
          :show-next-button=false
          :show-prev-button=false
          :show-playback-rate=false
          :show-progress-bar=false
          :is-loop=false
          :before-play="handleBeforePlay"
        />
      </div>
      <span class="audio-header">COMMERCIEEL</span>
    </div>
    <div class="uk-flex uk-flex-column demo-images">
      <img src="../assets/images/zakelijk@2x.jpg">
      <div class="audio-player-styling">
        <audio-player
          ref="audioPlayerZakelijk"
          :audio-list="audioListZakelijk.map(elm => elm.url)"
          theme-color="#3E332C"
          :show-next-button=false
          :show-prev-button=false
          :show-playback-rate=false
          :show-progress-bar=false
          :is-loop=false
          :before-play="handleBeforePlay"
        />
      </div>
      <span class="audio-header">ZAKELIJK</span>
    </div>
    <div class="uk-flex uk-flex-column demo-images">
      <img src="../assets/images/vriendelijk@2x.jpg">
      <div class="audio-player-styling">
        <audio-player
          ref="audioPlayerVriendelijk"
          :audio-list="audioListVriendelijk.map(elm => elm.url)"
          theme-color="#3E332C"
          :show-next-button=false
          :show-prev-button=false
          :show-playback-rate=false
          :show-progress-bar=false
          :is-loop=false
          :before-play="handleBeforePlay"
        />
      </div>
      <span class="audio-header">VRIENDELIJK</span>
    </div>
  </div>
</template>

<script>
import AudioPlayer from '@liripeng/vue-audio-player';

export default {
  name: 'AudioBlock.vue',
  components: {
    AudioPlayer,
  },
  data() {
    return {
      currentAudioName: '',
      audioListCommercieel: [
        {
          name: 'voicedemo_commercieel',
          url: 'https://iungo-it.nl/mp3/Voicedemo_Commercieel.mp3',
        },
      ],
      audioListZakelijk: [
        {
          name: 'voicedemo_zakelijk',
          url: 'https://iungo-it.nl/mp3/Voicedemo_Zakelijk.mp3',
        },
      ],
      audioListVriendelijk: [
        {
          name: 'voicedemo_vriendelijk',
          url: 'https://iungo-it.nl/mp3/Voicedemo_Vriendelijk.mp3',
        },
      ],
    };
  },
  methods: {
    // Use this function if you want to do something before you start playing
    handleBeforePlay(next) {
      if (
        this.$refs.audioPlayerCommercieel.isPlaying
        || this.$refs.audioPlayerZakelijk.isPlaying
        || this.$refs.audioPlayerVriendelijk.isPlaying
      ) {
        this.$refs.audioPlayerVriendelijk.pause();
        this.$refs.audioPlayerZakelijk.pause();
        this.$refs.audioPlayerCommercieel.pause();
      }

      next(); // Start play
    },
  },
};
</script>

<style scoped>
img {
  width: 100%;
  max-width: 350px;
}

audio {
  max-width: 350px;
  width: 100%;
}
</style>
